import { postRequest, getRequest, deleteRequest } from "../../utils/apiHelper";

export const projectService = {
    createProject,
    getProjects,
    getLeadsCount,
    updateDND,
    removeProjectUser,
    deleteUserFromAgency,
    getProjectDetail,
    getProjectsFilter,
    getAllTags,
    completeProject,
    deleteProject,
    archiveProject,

    getBrief,
    updateBrief,
    updateContactDetails,
    updateAboutDetails,
    saveDuplicateProject,

    getAllNotes,
    getNote,
    addNote,
    updateNote,
    shareNote,
    deleteNote,


    getTeamMembers,
    getActiveTeamMembers,
    getProjectTeamUsers,
    newUserInvitationAccept,
    inviteNewUsers,
    inviteExistingUsers,
    getProjectInviteData,

    createNewTask,
    getAllTasks,
    getCurrentTask,
    deleteTask,
    updatecurrentTask,
    getTaskFilter,
    completeTask,
    getPTaskTags,
    createTaskNote,
    getAllTaskNote,
    deleteTaskNote,

    saveProjectPreference,
    getTaskCounts,

    // Lead Pages
    getLeadPages,
    getPageById,
    createPageFolder,
    editPageFolder,
    createPage,
    deleteFolder,
    deletePage,
    updatePage,
    getSubpages,
    resetLeadResources,

    // Lead Contacts
    getLeadContacts,
    createLeadContact,
    deleteLeadContact,
};

//create new project (now uses leads endpoint)
async function createProject(params) {
    const response = await postRequest("leads/create", params);
    return response;
}

//get projects (now uses leads endpoint)
async function getProjects(params) {
    const response = await postRequest("leads/", params);
    return response;
}

//get leads count
async function getLeadsCount(params) {
    const response = await postRequest("leads/count", params);
    return response;
}

async function getAllTags(params) {
    const response = await postRequest("leads/getAllTags", params);
    return response;
}

//get projects (now uses leads endpoint)
async function getProjectsFilter(params) {
    const response = await postRequest("leads/filter", params);
    return response;
}

//get project detail (now uses leads endpoint)
async function getProjectDetail(params) {
    const response = await getRequest(`leads/${params.id}`);
    return response;
}

//add note
async function updateDND(params) {
    const response = await postRequest("project/updateDND", params);
    return response;
}

//add note
async function removeProjectUser(params) {
    const response = await postRequest("project/removeProjectUser", params);
    return response;
}

// delete user from agency
async function deleteUserFromAgency(params) {
    const response = await postRequest("profile/deleteUser", params);
    return response;
}

//complete Project (now uses leads endpoint)
async function completeProject(params) {
    const response = await postRequest("leads/complete", params);
    return response;
}

//delete Project (now uses leads endpoint)
async function deleteProject(params) {
    const response = await postRequest("leads/remove", params);
    return response;
}

//archive Project (now uses leads endpoint)
async function archiveProject(params) {
    const response = await postRequest("leads/archive", params);
    return response;
}

//getProjectInviteData
async function getProjectInviteData(params) {
    const response = await postRequest("project/projectInviteData", params);
    return response;
}

/********************************BRIEF DETAILS**************************************************************** */

//get brief (now uses leads endpoint)
async function getBrief(params) {
    const response = await postRequest("leads/brief/get", params);
    return response;
}

//update brief (now uses leads endpoint)
async function updateBrief(params) {
    const response = await postRequest("leads/brief/update", params);
    return response;
}

//update contact details (now uses leads endpoint)
async function updateContactDetails(params) {
    const response = await postRequest("leads/contact-details", params);
    return response;
}

//update about details
async function updateAboutDetails(params) {
    const response = await postRequest("leads/about-details", params);
    return response;
}

//create duplicate project
async function saveDuplicateProject(params) {
    const response = await postRequest("project/create_clone", params);
    return response;
}

/********************************NOTES DETAILS**************************************************************** */


//get all notes
async function getAllNotes(params) {
    const response = await postRequest("project/note/getAll", params);
    return response;
}

//get one note
async function getNote(params) {
    const response = await postRequest("project/note/getOne", params);
    return response;
}

//add note
async function addNote(params) {
    const response = await postRequest("project/note/add", params);
    return response;
}

//update note
async function updateNote(params) {
    const response = await postRequest("project/note/update", params);
    return response;
}

//share note
async function shareNote(params) {
    const response = await postRequest("project/note/share", params);
    return response;
}

//Delete current Notes
async function deleteNote(params) {
    const response = await postRequest("project/note/del", params);
    return response;
}

/************************************TEAMS DETAILS*********************************************************** */

//get project team users
async function getProjectTeamUsers(params) {
    const response = await getRequest(`project/team/${params.id}`);
    return response;
}


//add note
async function inviteExistingUsers(params) {
    const response = await postRequest("project/existingInvite", params);
    return response;
}

//get Team Members
async function getTeamMembers(params) {
    const response = await postRequest("project/getTeamMembers", params);
    return response;
}

//get Team Members
async function getActiveTeamMembers(params) {
    const response = await postRequest("project/getActiveTeamMembers", params);
    return response;
}

//get Team Members
async function newUserInvitationAccept(params) {
    const response = await postRequest("project/inviteAccept", params);
    return response;
}

//add note
async function inviteNewUsers(params) {
    const response = await postRequest("project/newInvite", params);
    return response;
}

/***************************************TASK DETAILS****************************************************** */

//create new task
async function createNewTask(params) {
    const response = await postRequest("project/task/createNew", params);
    return response;
}

//get all task
async function getAllTasks(params) {
    const response = await postRequest("project/task/getAll", params);
    return response;
}

//get current task
async function getCurrentTask(params) {
    const response = await postRequest("project/task/getOne", params);
    return response;
}

//get current task
async function deleteTask(params) {
    const response = await postRequest("project/task/del", params);
    return response;
}

//get current task
async function updatecurrentTask(params) {
    const response = await postRequest("project/task/update", params);
    return response;
}

//create new profile
async function getTaskFilter(params) {
    const response = await postRequest("project/task/filter", params);
    return response;
}

//complete task
async function completeTask(params) {
    const response = await postRequest("project/task/complete", params);
    return response;
}

//task tags get
async function getPTaskTags(params) {
    const response = await postRequest("project/task/tags", params);
    return response;
}

//create task note
async function createTaskNote(params) {
    const response = await postRequest("task/notes/create", params);
    return response;
}

//get project task note
async function getAllTaskNote(params) {
    const response = await postRequest("task/notes", params);
    return response;
}

//delete task note
async function deleteTaskNote(params) {
    const response = await deleteRequest("task/notes", params);
    return response;
}

async function  saveProjectPreference(params){
    const response = await postRequest("project/savePreference", params);
    return response;
}

//get task counts for multiple projects (now uses leads endpoint)
async function getTaskCounts(params) {
    const response = await postRequest("leads/taskCounts", params);
    return response;
}

/***************************************LEAD PAGES DETAILS****************************************************** */

// Get folders with pages for a lead
async function getLeadPages(params) {
    const response = await getRequest(`leads/${params.lead_id}/pages`);
    return response;
}

// Get page by ID
async function getPageById(params) {
    const response = await getRequest(`leads/pages/${params.id}`);
    return response;
}

// Create lead page folder
async function createPageFolder(params) {
    const response = await postRequest("leads/pages/folder", params);
    return response;
}

// Edit lead page folder
async function editPageFolder(params) {
    const response = await postRequest("leads/pages/folder/edit", params);
    return response;
}

// Create lead page
async function createPage(params) {
    const response = await postRequest("leads/pages", params);
    return response;
}

// Delete folder
async function deleteFolder(params) {
    const response = await postRequest("leads/pages/folder/delete", params);
    return response;
}

// Reset lead resources to default templates
async function resetLeadResources(params) {
    const response = await postRequest("leads/pages/reset", params);
    return response;
}

// Delete page
async function deletePage(params) {
    const response = await postRequest("leads/pages/delete", params);
    return response;
}

// Update page
async function updatePage(params) {
    const response = await postRequest("leads/pages/update", params);
    return response;
}

// Get subpages of a page
async function getSubpages(params) {
    const response = await getRequest(`leads/pages/${params.id}/subpages`);
    return response;
}

/************************************LEAD CONTACTS*********************************************************** */

// Get all contacts for a lead
async function getLeadContacts(params) {
    const response = await postRequest("leads/contact/get", params);
    return response;
}

// Create a new contact for a lead
async function createLeadContact(params) {
    const response = await postRequest("leads/contact/create", params);
    return response;
}

// Delete a contact
async function deleteLeadContact(params) {
    const response = await postRequest("leads/contact/delete", params);
    return response;
}
